<template>
  <div>
    <download-excel
      style="width: 100px"
      :data="data"
      :fields="json_fields"
      type="xls"
      name="提现审核图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-modal v-model="visibletwo" title="审核通过" @ok="handleOktwo">
      <span>审核方式</span>
      <a-radio-group
        @change="onChange"
        name="radioGroup"
        :default-value="1"
        v-model="right"
      >
        <a-radio :value="1">支付宝</a-radio>
        <a-radio :value="2">银行卡</a-radio>
      </a-radio-group>
      <div v-if="right == 1">
        <p>提现方式</p>
        <a-input
          v-model="formStateTrue.payMethodStr"
          placeholder="Basic usage"
        />
        <p>申请金额</p>
        <a-input
          v-model="formStateTrue.moneyChange"
          placeholder="Basic usage"
        />
        <p>打款金额</p>
        <a-input v-model="formStateTrue.moneyClean" placeholder="Basic usage" />
      </div>
      <div v-else>
        <p>提现方式</p>
        <a-input
          v-model="formStateTruetwo.payMethodStr"
          placeholder="Basic usage"
        />
        <p>申请金额</p>
        <a-input
          v-model="formStateTruetwo.moneyChange"
          placeholder="Basic usage"
        />
        <p>打款金额</p>
        <a-input
          v-model="formStateTruetwo.moneyClean"
          placeholder="Basic usage"
        />
        <p>汇款凭证</p>
        <a-upload
          v-model="formStateTruetwo.certificate"
          name="file"
          :multiple="true"
          :headers="headers"
          :customRequest="upload"
          @change="handleChange"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            上传
          </a-button>
        </a-upload>
      </div>
    </a-modal>
    <a-modal
      v-model="visible"
      title="审核不通过"
      @ok="handleOk"
      :maskStyle="{ opacity: 0.1 }"
      cancelText="取消"
      okText="确定"
    >
      <p>原因</p>
      <a-textarea
        v-model="formState.remark"
        placeholder="请输入审核不通过原因"
        :rows="4"
      />
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 1300 }"
    >
      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/withdrawalAudit/withdrawalDetails?objId=${operate.objId}`
            )
          "
          >详情</a
        >
        <a href="javascript:;" @click="open(operate)">通过</a>
        <a v-on:click.prevent="showModal(operate)">不通过</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import { withdrawalList } from "@/api/orderApi.js";
import { withdrawalAudit, financeAuditSeach } from "@/api/homeApi.js";
import { picUpload } from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "财务单号",
    width: 200,
    dataIndex: "financeNo",
  },
  {
    title: "用户",
    dataIndex: "aimsName",
  },
  {
    title: "财务类型",
    dataIndex: "financeType",
  },
  {
    title: "提交金额",
    dataIndex: "moneySubmit",
  },
  {
    title: "落地金额",
    dataIndex: "name",
  },
  {
    title: "佣金金额",
    dataIndex: "moneyRate",
  },
  {
    title: "交易方式",
    dataIndex: "payMethodStr",
  },
  {
    title: "交易状态",
    dataIndex: "financeStatusStr",
  },
  {
    title: "创建时间",
    width: 200,
    dataIndex: "createTime",
  },
  {
    title: "操作",
    dataIndex: "operate",
    width: 150,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      right: 1,
      json_fields: {
        编号: "objId",
        财务单号: "financeNo",
        用户: "aimsName",
        财务类型: "financeType",
        提交金额: "moneySubmit",
        落地金额: "name",
        佣金金额: "moneyRate",
        交易方式: "payMethodStr",
        交易状态: "financeStatusStr",
        创建时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibletwo: false,
      formState: {
        financeNo: "",
        pass: false,
        remark: "",
      },
      formStateTrue: {
        financeNo: "",
        pass: true,
        moneyChange: "",
        moneyClean: "",
      },
      formStateTruetwo: {
        financeNo: "",
        pass: true,
        moneyChange: "",
        moneyClean: "",
        certificate: "",
      },
    };
  },
  mounted() {
    this.getWithdrawalListData();
  },
  props: ["formInline"],
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      withdrawalList(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    open(row) {
      console.log(row);
      this.formStateTrue.financeNo = row.financeNo;
      this.formStateTrue.payMethodStr = row.payMethodStr;
      this.formStateTrue.moneyChange = row.moneyChange;

      this.formStateTruetwo.financeNo = row.financeNo;
      this.formStateTruetwo.payMethodStr = row.payMethodStr;
      this.formStateTruetwo.moneyChange = row.moneyChange;
      this.visibletwo = true;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getWithdrawalListData() {
      withdrawalList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(res);
      });
    },
    //
    onChange(e) {
      console.log(`a-switch to ${e.target.value}`);
      this.right = e.target.value;
    },
    //
    showModal(row) {
      console.log(row);
      this.formState.financeNo = row.financeNo;
      this.visible = true;
    },
    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error(this.$file_max_size_text);
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.formStateTruetwo.certificate = res.data;
        })
        .catch((err) => {
          message.error(this.$file_max_size_text);
        });
    },
    handleOk() {
      console.log();
      this.visible = false;
      withdrawalAudit(this.formState).then((res) => {
        message.success(res.info);
        this.getWithdrawalListData();
        console.log(res);
      });
    },
    query() {
      this.loading = true;
      financeAuditSeach(
        10,
        1,
        this.formInline.financeNo,
        this.formInline.name
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    handleOktwo() {
      this.visibletwo = false;
      if (this.right === 1) {
        withdrawalAudit(this.formStateTrue).then((res) => {
          message.success(res.info);
          this.getWithdrawalListData();
          console.log(res);
        });
      } else {
        withdrawalAudit(this.formStateTruetwo).then((res) => {
          message.success(res.info);
          this.getWithdrawalListData();
          console.log(res);
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/financialManagement/withdrawalAudit/withdrawalAuditContent.vue